import { StorageService } from "@/services/storage.service";
import UserService from "../services/userOld.service";
import { EventBus } from "@/event-bus";
import { isEmpty } from "lodash";

const state = {
  showMainMenu: false,
  showConfirmIdentityModal: false,
  showSignInModal: false,
  showApplyDialog: false,
  showInfoRequestDialog: false,
  showHideFamilyDialog: false,
  showGdprModal: false,
  hideCovidAlert: StorageService.get("hideCovid"),
  hideCookieAlert: StorageService.get("hideCookie"),
  analyticsDisabled: StorageService.get("analyticsDisabled"),
  invitation: StorageService.get("invitation"),
  alreadyUpdatedAvailability: false,
  needs_availability_update: false,
  needs_availability_update_language: "",
  showUpdateAvailabilityModal: false,
  topMenu: {
    left: [],
    right: []
  },
  notification: {
    show: false,
    heading: "",
    desc: "",
    buttons: {
      okay: {
        text: "",
        action: null
      },
      cancel: {
        text: "",
        action: null
      }
    },
    icon: {
      show: false,
      type: "dollar"
    }
  }
};

const getters = {
  GET_NEEDS_AVAILABILITY_UPDATE_LANGUAGE: state => {
    return state.needs_availability_update_language;
  },

  GET_NEEDS_AVAILABILITY_UPDATE: state => {
    return state.needs_availability_update;
  },

  GET_SHOW_UPDATE_AVAILABILITY_DIALOG: state => {
    return state.showUpdateAvailabilityModal;
  },

  isActiveInvitation: state => {
    return state.invitation ? true : false;
  },

  GET_INVITATION: () => {
    return StorageService.get("invitation");
  },

  showMainMenu: state => {
    return state.showMainMenu;
  },

  showGdprModal: state => {
    return state.showGdprModal;
  },

  showConfirmIdentityModal: state => {
    return state.showConfirmIdentityModal;
  },

  showSignInModal: state => {
    return state.showSignInModal;
  },

  hideCovidAlert: state => {
    return state.hideCovidAlert ? true : false;
  },

  hideCookieAlert: state => {
    return state.hideCookieAlert ? true : false;
  },

  analyticsDisabled: state => {
    return state.analyticsDisabled ? true : false;
  },
  topMenu: state => state.topMenu,
  notification: state => state.notification
};

const actions = {
  async hideCovidAlert({ state }) {
    try {
      StorageService.save("hideCovid", true);
      state.hideCovidAlert = StorageService.get("hideCovid");
      return true;
    } catch (e) {
      return false;
    }
  },

  async hideCookieAlert({ state }) {
    try {
      StorageService.save("hideCookie", true);
      state.hideCookieAlert = StorageService.get("hideCookie");
      return true;
    } catch (e) {
      return false;
    }
  },

  async disableAnalytics({ state }) {
    try {
      StorageService.save("analyticsDisabled", true);
      state.analyticsDisabled = StorageService.get("analyticsDisabled");
      return true;
    } catch (e) {
      return false;
    }
  },

  async enableAnalytics({ state }) {
    try {
      StorageService.remove("analyticsDisabled");
      state.analyticsDisabled = false;
      return true;
    } catch (e) {
      return false;
    }
  },

  async invitation({ state, commit }, uid) {
    try {
      await StorageService.save("invitation", uid);
      state.invitation = StorageService.get("invitation");

      await UserService.checkUpdateAvailabilityNeed(uid)
        .then(data => {
          let needs_availability_update = data.needs_availability_update;
          let language = data.language;

          commit("SET_NEEDS_AVAILABILITY_UPDATE", needs_availability_update);
          commit("SET_NEEDS_AVAILABILITY_UPDATE_LANGUAGE", language);
          location.reload();
        })
        .catch(() => {});
      return true;
    } catch (e) {
      return false;
    }
  },

  async checkUpdateAvailabilityNeed({ commit }) {
    try {
      let invitationId = await StorageService.get("invitation");
      if (
        invitationId !== null &&
        invitationId !== "" &&
        typeof invitationId !== "undefined"
      ) {
        await UserService.checkUpdateAvailabilityNeed(invitationId)
          .then(data => {
            let needs_availability_update = data.needs_availability_update;
            let language = data.language;

            commit("SET_NEEDS_AVAILABILITY_UPDATE", needs_availability_update);
            commit("SET_NEEDS_AVAILABILITY_UPDATE_LANGUAGE", language);
          })
          .catch(() => {
            return false;
          });
      }

      return state.needs_availability_update_language;
    } catch (e) {
      return "";
    }
  },

  setupInvitation({ dispatch }, uid) {
    try {
      StorageService.remove("invitation");
      dispatch("invitation", uid);
      return true;
    } catch (e) {
      return false;
    }
  },

  getInvitationUid() {
    try {
      return StorageService.get("invitation");
    } catch (e) {
      return null;
    }
  },

  async alreadyUpdatedAvailability({ state, commit }, startdate) {
    try {
      commit("SET_UPDATED_AVAILABILITY_DATE", startdate);
      commit("SET_ALREADY_UPDATED_AVAILABILITY");
      state.alreadyUpdatedAvailability = true;
      return true;
    } catch (e) {
      return false;
    }
  }
};

const mutations = {
  SET_UPDATED_AVAILABILITY_DATE(state, startdate) {
    EventBus.$emit("on-change-start-date", startdate);
  },

  SET_ALREADY_UPDATED_AVAILABILITY(state) {
    state.alreadyUpdatedAvailability = true;
  },

  SET_NEEDS_AVAILABILITY_UPDATE_LANGUAGE(state, language) {
    state.needs_availability_update_language = language;
  },

  SET_NEEDS_AVAILABILITY_UPDATE(state, result) {
    state.needs_availability_update = result;
  },

  SET_SHOW_UPDATE_AVAILABILITY_DIALOG(state) {
    state.showUpdateAvailabilityModal = true;
  },

  SET_SHIDE_UPDATE_AVAILABILITY_DIALOG(state) {
    state.showUpdateAvailabilityModal = false;
  },

  showMainMenu(state) {
    state.showMainMenu = true;
  },

  hideMainMenu(state) {
    state.showMainMenu = false;
  },

  showConfirmIdentityModal(state) {
    state.showConfirmIdentityModal = true;
  },

  hideConfirmIdentityModal(state) {
    state.showConfirmIdentityModal = false;
  },

  showSignInModal(state) {
    state.showSignInModal = true;
  },

  hideSignInModal(state) {
    state.showSignInModal = false;
  },

  showApplyDialog(state) {
    state.showApplyDialog = true;
  },

  showInfoRequestDialog(state) {
    state.showInfoRequestDialog = true;
  },

  hideInfoRequestDialog(state) {
    state.showInfoRequestDialog = false;
  },

  hideApplyDialog(state) {
    state.showApplyDialog = false;
  },

  showHideFamilyDialog(state) {
    state.showHideFamilyDialog = true;
  },

  hideHideFamilyDialog(state) {
    state.showHideFamilyDialog = false;
  },

  showGdprModal(state) {
    state.showGdprModal = true;
  },

  hideGdprModal(state) {
    state.showGdprModal = false;
  },
  setTopMenu(state, data) {
    state.topMenu.left =
      !isEmpty(data) && Object.prototype.hasOwnProperty.call(data, "left")
        ? data.left
        : [];
    state.topMenu.right =
      !isEmpty(data) && Object.prototype.hasOwnProperty.call(data, "right")
        ? data.right
        : [];
  },
  showNotification(state, data = {}) {
    if (isEmpty(data.heading) && isEmpty(data.desc)) {
      return;
    }

    state.notification.heading = isEmpty(data.heading) ? "" : data.heading;
    state.notification.desc = isEmpty(data.desc) ? "" : data.desc;

    let okayBtn = !isEmpty(data.buttons) && !isEmpty(data.buttons.okay);
    let cancelBtn = !isEmpty(data.buttons) && !isEmpty(data.buttons.cancel);

    state.notification.buttons.okay = {
      text:
        okayBtn && !isEmpty(data.buttons.okay.text)
          ? data.buttons.okay.text
          : "",
      action:
        okayBtn && typeof data.buttons.okay.action === "function"
          ? data.buttons.okay.action
          : null
    };

    state.notification.buttons.cancel = {
      text:
        cancelBtn && !isEmpty(data.buttons.cancel.text)
          ? data.buttons.cancel.text
          : "",
      action:
        cancelBtn && typeof data.buttons.cancel.action === "function"
          ? data.buttons.cancel.action
          : ""
    };

    state.notification.icon = {
      show: data?.icon?.show || false,
      type: data?.icon?.type ?? "dollar"
    };

    state.notification.show = true;
  },
  hideNotification(state) {
    state.notification.show = false;
    state.notification.heading = "";
    state.notification.desc = "";
    state.notification.buttons.okay = {
      text: "",
      action: null
    };
    state.notification.buttons.cancel = {
      text: "",
      action: null
    };
    state.notification.icon = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
